import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import * as S from './styles';

interface Menu {
  name: string;
  route: string;
  icon?: ReactElement | null;
  children: Menu[];
  perm?: string;
}

interface Props {
  menu: Menu;
}

export const ItemSubMenu: React.FC<Props> = ({ menu }) => {
  return (
    <>
      <S.Item>
        <NavLink to={menu.route} activeClassName="sideBarLinkActive">
          {menu.icon}
          <S.LabelMenu>{menu.name}</S.LabelMenu>
        </NavLink>
      </S.Item>
    </>
  );
};
